export default __webpack_public_path__ + "static/media/Download.9a3b2651.svg";